import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormProvider, useForm } from 'react-hook-form';
import {
  ControlledTextInput,
  Label,
  WsButton,
  WsInputNumber,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { HeaderBox } from '../../components/HeaderBox';

const StyledLabel = styled(Label)(() => ({
  fontWeight: 'bold',
  minWidth: '351pt',
  lineHeight: '32pt',
}));
const DownloadLimit = () => {
  const methods = useForm();

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <HeaderBox mb={4}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          Download Limit and Email Notification
        </WsTypography>
        <WsButton type="submit" onClick={handleSubmit((d) => console.log(d))} size="small">
          Save
        </WsButton>
      </HeaderBox>
      <Grid container rowSpacing={2}>
        <Grid item sm={12} display="flex" direction="row" justifyContent="space-between">
          <StyledLabel>Limit the number of download records</StyledLabel>
          <WsInputNumber maxValue={10000} name="records" label="Default Value 2000, Max 10000 " />
        </Grid>

        <Grid item sm={12} display="flex" direction="row" justifyContent="space-between">
          <StyledLabel>Notify this email address when data is downloaded</StyledLabel>
          <ControlledTextInput placeholder="E-mail Address" name="email" variant="outlined" />
        </Grid>

        <Grid item mt={5}>
          <WsTypography variant={WsTypoVariants.BODY2}>
            Once you save your Settings, Refresh the page you are Downloading Data from.
          </WsTypography>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default DownloadLimit;
